import { CountryEnum } from "src/types/country";
import { ThirdServiceCategory } from "src/types/posCredential";

export const AUTHORIZED_SERVICES_OPERATIONAL = [
    ThirdServiceCategory.Deliveroo,
    ThirdServiceCategory.Ubereats,
    ThirdServiceCategory.Glovo,
];

export const AMPLITUDE_WELCOME_PAGE_KEY = "global-view";

export const COUNTRY_WITH_JUST_EAT_AVAILABLE = [CountryEnum.GB, CountryEnum.ES];
